const PREFIX = "imam:inbox:v1:";
export function inboxRecoveryKey(
  tenant: string,
  actor: string,
  context: string,
) {
  return `${PREFIX}${tenant}:${actor}:${context}`;
}
export interface InboxDraft {
  channel?: "email" | "chat";
  subject: string;
  body: string;
  recipient: string;
  session: string;
}
export function readInboxDraft(key: string): InboxDraft | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) ?? "null");
    return value &&
      (value.channel === undefined ||
        value.channel === "chat" ||
        value.channel === "email") &&
      ["subject", "body", "recipient", "session"].every(
        (field) => typeof value[field] === "string",
      )
      ? value
      : null;
  } catch {
    return null;
  }
}
export function saveInboxDraft(key: string, draft: InboxDraft | null) {
  try {
    if (draft) sessionStorage.setItem(key, JSON.stringify(draft));
    else sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
// Persistent recovery carries only command identity, never message bodies.
export function inboxPending(key: string): string | null {
  try {
    return localStorage.getItem(`${key}:pending`);
  } catch {
    return null;
  }
}
export function saveInboxPending(key: string, id: string | null) {
  try {
    if (id) localStorage.setItem(`${key}:pending`, id);
    else localStorage.removeItem(`${key}:pending`);
    return true;
  } catch {
    return false;
  }
}
export function clearInboxRecovery() {
  for (const name of ["sessionStorage", "localStorage"] as const) {
    try {
      const storage = window[name];
      for (let index = storage.length - 1; index >= 0; index--) {
        const key = storage.key(index);
        if (key?.startsWith(PREFIX)) storage.removeItem(key);
      }
    } catch {
      // Storage may be disabled; signing out must still complete.
    }
  }
}
